export default "__VITE_ASSET__C4p47wIL__"